var version = {
    "name":      "dativery",
    "buildDateCode": "20260514-125420",
    "buildDate": "Thu May 14 2026 12:54:20 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260514-125420",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;